import React, { Component } from 'react';
import { Redirect, withRouter} from 'react-router-dom';

import { request, handleRequestErrors } from '../../helpers/Requests'

import CsvDownloader from 'react-csv-downloader';

import { faFileDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { arrayParamBuilder, formatDate, renderSortColumn } from '../../utilities/Generic.js'

class ExportPeople extends Component {
  constructor(props) {
    super(props);

    this.renderSortColumn = renderSortColumn.bind(this);
  }

  emptyPeople(people) {
    if (people.length === 0) {
      return (
        <div className="long-tr">
          <div className="long-td">
            { this.emptyPeopleText() }
          </div>
        </div>
      )
    }
  }

  emptyPeopleText() {
    if (this.props.selected_location !== "" && this.props.type_of_person !== "" && this.props.page > 1) {
      return "No people to show on this page for this Location and Type."
    }
    else if (this.props.selected_location !== "" && this.props.type_of_person !== "") {
      return "No people to show for this Location and Type."
    }
    else if (this.props.selected_location !== "" && this.props.page > 1) {
      return "No people to show on this page for this Location."
    }
    else if (this.props.selected_location !== "") {
      return "No people to show for this Location."
    }
    else if (this.props.type_of_person !== "" && this.props.page > 1) {
      return "No people to show on this page for this Type."
    }
    else if (this.props.type_of_person !== "") {
      return "No people to show for this Type."
    }
    else if (this.props.page > 1) {
      return "No people to show on this page."
    }
    else {
      return "No people to show."
    }
  }

  customAttributeFinder(custom_attribute_id){
    return this.props.custom_attributes.find(custom_attribute => custom_attribute.id === custom_attribute_id)
  }

  personCustomAttributeFinder(person, custom_attribute_id){
    // returns empty object if person custom attribute is not available
    return person.custom_attributes.find(custom_attribute => custom_attribute.custom_attribute_id === custom_attribute_id) || {}
  }

  renderCustomAttributeHeaders() {
    let activeCustomAttributes = []

    this.props.custom_attribute_ids.forEach((custom_attribute_id) =>
      activeCustomAttributes.push(this.customAttributeFinder(custom_attribute_id))
    )

    return (
      <React.Fragment>
        {activeCustomAttributes.map((custom_attribute, index) => (
          <div className="th" key={"custom_attribute"+index}>{custom_attribute.name}</div>
        ))}
      </React.Fragment>
    )
  }

  renderPersonCustomAttributes(person) {
    return (
      <>
        {this.props.custom_attribute_ids.map((custom_attribute_id, index) => {
          const custom_attribute = this.personCustomAttributeFinder(person, custom_attribute_id)
          return (
            <div className="td" key={"custom_attribute"+index}>{custom_attribute.value}</div>
          )
        })}
      </>
    )
  }

  customAttributeCSV() {
    let array = []
    this.props.custom_attribute_ids.forEach((custom_attribute_id) => {
      const custom_attribute = this.customAttributeFinder(custom_attribute_id)

      array.push({ displayname: custom_attribute.name, id: custom_attribute.id.toString()})
    })
    return array
  }

  downloadCSV(people) {
    let filename = `people-export-${formatDate(new Date(), 0)}.csv`

    let columns = [
      { displayname: "First Name", id: "first_name" },
      { displayname: "Last Name", id: "last_name" },
      { displayname: "Email", id: "email" },
      { displayname: "Phone", id: "phone" },
      { displayname: "Type", id: "type_of_person" },
      { displayname: "Last Event", id: "last_login" },
      { displayname: "Last Updated At", id: "updated_at" },
      { displayname: "Number of Locations", id: "locations_count" },
      { displayname: "Number of Relationships", id: "relationships_count" },
      { displayname: "Covid Vaccination Pass Valid Until", id: "covid_pass_expiry_date" }
    ];

    columns = columns.concat(this.customAttributeCSV())

    // mapping custom attributes back into people using the custom_attribute_id as a key to match the keys in customAttributeCSV()
    people.forEach((person) => {
      person.custom_attributes.forEach((custom_attribute) => {
        person[custom_attribute.custom_attribute_id.toString()] = custom_attribute.value
      })
    })

    return (
      <CsvDownloader datas={() => this.getCSVData(people, columns)} columns={columns} filename={filename} className="edit-button download-csv" wrapColumnChar='"'>
        <div>
          <FontAwesomeIcon icon={faFileDownload} />
          <h4>{this.state.CSVDataLoading ? "Downloading additional data..." : "Download CSV"}</h4>
        </div>
      </CsvDownloader>
    )
  }

  async getCSVData(currentPageData, columns) {
    this.setState({ CSVDataLoading: true })
    let people = await this.recursivePageGrab(currentPageData)

    // mapping custom attributes back into people using the custom_attribute_id as a key to match the keys in customAttributeCSV()
    people.forEach((person) => {
      person.custom_attributes.forEach((custom_attribute) => {
        person[custom_attribute.custom_attribute_id.toString()] = custom_attribute.value
      })
    })

    if (people.length === 0) {
      people = [{[columns[0].id]: this.emptyVisitorsText()}]
    }
    this.setState({ CSVDataLoading: false })

    return people
  }

  async recursivePageGrab(currentPageData, previousData = [], page = 1) {
    const [newData, moreRecursionRequired] = page === parseInt(this.props.page) ? [currentPageData, this.state.people.length === 250] : await this.grabData(page)
    const data = previousData.concat(newData)

    return moreRecursionRequired ? this.recursivePageGrab(currentPageData, data, page + 1) : data
  }

  async grabData(page) {
    let params = `people[location]=${this.props.selected_location}&people[person]=${this.props.type_of_person}${arrayParamBuilder("people", "tag_ids", this.props.tag_ids)}&people[search]=${this.props.search}&people[custom_attribute_search]=${this.props.custom_attribute_search}${arrayParamBuilder("people", "custom_attribute_ids", this.props.custom_attribute_ids)}&page=${page}&sort=${this.props.sort}&direction=${this.props.direction}`

    let people = await request("GET", `/v1/a/exports/people?${params}`, null, () => {this.setState({ unauthorized: true })})

    return [people, people.length === 250]
  }

  renderExpired(date) {
    const units = date.split("/")
    const day = units[0]
    const month = units[1]
    const year = units[2]

    const parsedDate = new Date(`${year}/${month}/${day}`)
    const currentDate = new Date().setHours(0,0,0,0)

    if (parsedDate < currentDate) {
      return (
        <div className="td red">{date}</div>
      )
    }
    else {
      return (
        <div className="td">{date}</div>
      )
    }
  }

  renderPageButtons(page, records) {
    if (parseInt(page) === 1 && records.length < 250) {
      return
    }
    else {
      return (
        <div>
          <button className="button new-button" onClick={this.props.handleNextPage} disabled={(records.length < 250)}>Next Page</button>
          <button className="button new-button" onClick={this.props.handlePreviousPage} disabled={(this.props.page < 2)}>Previous Page</button>
        </div>
      )
    }
  }

  render() {
    const { people, loaded, error, unauthorized, invalid_params } = this.state;

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (invalid_params === true) {
      return <p>Waiting for valid date range ...</p>;
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {
      return (
        <div className="relative">
          {this.downloadCSV(people)}

          <div className="table big-table top-padding" data-testid="table">
            <div className="tr heading">
              {this.renderSortColumn("First name", "first_name")}
              {this.renderSortColumn("Last name", "last_name")}
              {this.renderSortColumn("Email", "email")}
              {this.renderSortColumn("Phone", "phone")}
              {this.renderSortColumn("Type", "type_of_person")}
              {this.renderSortColumn("Last Event", "last_login")}
              {this.renderSortColumn("Last Updated At", "updated_at")}
              <div className="th not-sortable">Number of Locations</div>
              <div className="th not-sortable">Number of Relationships</div>
              {this.renderSortColumn("Covid Vaccination Pass Valid Until", "covid_pass_expiry_date")}
              {this.renderCustomAttributeHeaders()}
            </div>

            {people.map((person, index) => (
              <div className="tr event" key={index}>
                <div className="td">{person.first_name}</div>
                <div className="td">{person.last_name}</div>
                <div className="td">{person.email}</div>
                <div className="td">{person.phone}</div>
                <div className="td">{person.type_of_person}</div>
                <div className="td">{person.last_login}</div>
                <div className="td">{person.updated_at}</div>
                <div className="td">{person.locations_count}</div>
                <div className="td">{person.relationships_count}</div>
                {this.renderExpired(person.covid_pass_expiry_date)}
                {this.renderPersonCustomAttributes(person)}
              </div>
            ))}
            </div>

          {this.emptyPeople(people)}
          {this.renderPageButtons(this.props.page, people)}
        </div>
      );
    }
  }

  state = {
    people: [],
    loaded: false,
    error: null,
    unauthorized: null,
    invalid_params: false
  };

  componentDidMount() {
    if (this.props.date_from !== "" && this.props.date_to !== "") {
      let params = `people[location]=${this.props.selected_location}&people[person]=${this.props.type_of_person}${arrayParamBuilder("people", "tag_ids", this.props.tag_ids)}&people[search]=${this.props.search}&people[custom_attribute_search]=${this.props.custom_attribute_search}${arrayParamBuilder("people", "custom_attribute_ids", this.props.custom_attribute_ids)}&page=${this.props.page}&sort=${this.props.sort}&direction=${this.props.direction}`

      request("GET", `/v1/a/exports/people?${params}`, "", () => {this.setState({ unauthorized: true })})
        .then(data => {this.setState({ people: data, loaded: true })})
        .catch(error => handleRequestErrors(this, error, {loaded: true }))
    }
    else {
      this.setState({
        invalid_params: true
      })
    }
  }
}

export default withRouter(ExportPeople);
